import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Building2, Users } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../components/ui/button";
import SocieteSearch from "./SocieteSearch";

export default function SocietesHeader({
  search = "",
  onSearchChange,
  selectedForm = "TOUS",
  onFormChange
}) {
  const navigate = useNavigate();

  return (
    <div
      className="
        relative z-20
        flex shrink-0 flex-col
        gap-6
        overflow-visible
        workspace-card
        bg-cover bg-center bg-no-repeat
        p-4 sm:p-6
        mb-6
        xl:flex-row xl:items-center xl:justify-between
      "
      style={{
        backgroundImage: "url('/assets/backgrounds/castle_bg.png')",
      }}
    >
      {/* Voile sombre utilisant les tokens Hipparchus */}
      <div
        aria-hidden="true"
        className="
          pointer-events-none
          absolute inset-0 z-0
          rounded-[var(--hp-radius-lg)]
          bg-overlay
        "
      />

      {/* Partie gauche : titre et icône */}
      <div
        className="
          relative z-10
          flex min-w-0 shrink-0
          flex-col items-start
          gap-3
          sm:flex-row sm:items-center sm:gap-4
        "
      >
        <div
          className="
            flex h-12 w-12 shrink-0
            items-center justify-center
            rounded-full
            bg-secondary
            text-inverse
            shadow-hp-sm
          "
        >
          <Building2 className="h-6 w-6" />
        </div>

        <div className="min-w-0">
          <h1 className="text-2xl font-bold text-inverse">
            Cartographie des Personnes Morales
          </h1>

          <p className="mt-1 text-sm text-inverse opacity-80">
            Inventaire patrimonial des sociétés, holdings familiales, SCI de gestion et structures d'exploitation.
          </p>
        </div>
      </div>

      {/* Partie droite : actions */}
      <div
        className="
          relative z-50
          flex w-full min-w-0
          flex-col gap-3
          xl:w-auto xl:flex-row xl:items-center
        "
      >
        <div
          className="
            relative z-[60]
            flex flex-wrap items-center
            gap-3
          "
        >
          <AnimatePresence mode="popLayout">
            <motion.div
              key="actions-single"
              layout
              initial={{ opacity: 0, filter: "blur(4px)", y: -5 }}
              animate={{ opacity: 1, filter: "blur(0px)", y: 0 }}
              exit={{ opacity: 0, filter: "blur(4px)", y: 5 }}
              transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
              className="flex items-center gap-3"
            >
              <Button
                variant="accent"
                onClick={() => navigate("/prospects/familles")}
              >
                <Users className="h-4 w-4 mr-2" />
                Foyers et familles
              </Button>

              <div className="ml-2 pl-2 border-l border-workspace hidden md:block">
                <SocieteSearch
                  search={search}
                  setSearch={onSearchChange}
                  selectedForm={selectedForm}
                  setSelectedForm={onFormChange}
                />
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}
